import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { AgentComparePage } from './pages/AgentComparePage'
import { AgentSummaryPage } from './pages/AgentSummaryPage'
import { AgentsIndexPage } from './pages/AgentsIndexPage'
import { AppointmentsPage } from './pages/AppointmentsPage'
import { CallDetail } from './pages/CallDetail'
import { CallsPage } from './pages/CallsPage'
import { CoachScorecardPage } from './pages/CoachScorecardPage'
import { HomePage } from './pages/HomePage'
import { LeaderboardPage } from './pages/LeaderboardPage'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/calls" element={<CallsPage />} />
        <Route path="/calls/:id" element={<CallDetail />} />
        <Route path="/agents" element={<AgentsIndexPage />} />
        <Route path="/agents/compare" element={<AgentComparePage />} />
        <Route path="/agents/:vici_user" element={<AgentSummaryPage />} />
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/coach-scorecard" element={<CoachScorecardPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

function NotFound() {
  return (
    <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-8 text-center text-sm text-slate-400">
      404 — nothing here.
    </div>
  )
}
